import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - ${comic.categoryLabel}漫画封面`}
          title={`${comic.title} - ${comic.categoryLabel}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            comic.status === 'ongoing'
              ? 'bg-primary-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {comic.statusLabel}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-black/60 text-white">
            {comic.categoryLabel}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-white text-xs">
            <i className="ri-star-fill text-accent-400 text-xs" />
            <span>{comic.rating}</span>
            <span className="mx-1 opacity-50">|</span>
            <i className="ri-eye-line text-xs" />
            <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}